import React from 'react';
import { Link } from 'react-router-dom';
import { requestUrl } from '@/constants/urls';
import RequestIcon from './RequestIcon';

const RequestsCardHeader = ({ allowTransfer, request }) => (
  <div className="aridhia-card-header-content w-100">
    <span title={request.name}>
      <RequestIcon allowTransfer={allowTransfer} request={request} />
      <Link to={requestUrl(request)} title={request.name}>{request.name}</Link>
    </span>
  </div>
);

export default RequestsCardHeader;
